import {useEffect} from "react";
import {AD_TAGS, BASE_PAGE_AD_ID} from "@/components/adSections/index";
import useHasHydrated from "@/hooks/useHasHydrated";
import {hideAdsWrappers, resizeAdsZoom} from "@/utils/ad";
import {loadAndDisplayAds} from "@/utils/adgw";
import {log} from "@/utils/log";

// The ads of a page: loaded once the page has hydrated and when the content has some. Once displayed, the wrappers the ad server leaves are hidden and
// the zoom of the frames fitted every 700 ms, six times, and again whenever the window is resized. The same on every page that shows ads.
export function usePageAds(adsEnabled?: boolean) {
  const hasHydrated = useHasHydrated();
  useEffect(() => {
    if (!hasHydrated || typeof window === "undefined") return;
    let interval: ReturnType<typeof setInterval> | undefined;

    if (adsEnabled) {
      loadAndDisplayAds(BASE_PAGE_AD_ID, AD_TAGS)
        .then((displayed) => {
          if (!displayed) return;
          let callCount = 0;

          interval = setInterval(() => {
            hideAdsWrappers();
            callCount += 1;

            if (callCount === 6) {
              clearInterval(interval);
            }
            resizeAdsZoom();
          }, 700);

          window.addEventListener("resize", resizeAdsZoom);
        })
        .catch((error: unknown) => {
          log.error({event: "ads.load_failed", err: error}, "error ad loading");
        });
    }
    return () => {
      if (interval) clearInterval(interval);
      window.removeEventListener("resize", resizeAdsZoom);
    };
  }, [hasHydrated, adsEnabled]);
}
